const EditIcon = () => (
  <svg width="14" height="14" viewBox="0 0 14 14" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path d="M12.9155 1.08028C12.734 0.896469 12.5179 0.750521 12.2796 0.650908C12.0412 0.551295 11.7855 0.5 11.5272 0.5C11.269 0.5 11.0132 0.551295 10.7749 0.650908C10.5366 0.750521 10.3205 0.896469 10.139 1.08028L8.89062 2.3482L11.6475 5.10511L12.896 3.8567C13.081 3.67654 13.2285 3.46142 13.3298 3.22382C13.4311 2.98621 13.4842 2.73086 13.486 2.47257C13.4878 2.21428 13.4383 1.9582 13.3404 1.7192C13.2424 1.48019 13.098 1.26302 12.9155 1.08028Z" fill="var(--s247-primary, #B3446D)"/>
    <path d="M7.96666 3.27148L2.51136 8.72679C2.46246 8.77706 2.42087 8.83397 2.38782 8.89584L0.580226 12.5435C0.527786 12.642 0.50156 12.7523 0.504071 12.8638C0.506582 12.9754 0.537744 13.0844 0.594561 13.1804C0.651379 13.2764 0.73194 13.3561 0.828499 13.412C0.925057 13.4679 1.03437 13.498 1.14591 13.4994C1.24498 13.4998 1.34284 13.4775 1.43201 13.4343L5.07971 11.6267C5.14157 11.5937 5.19848 11.5521 5.24876 11.5032L10.7041 6.0479L7.96666 3.27148Z" fill="var(--s247-primary, #B3446D)"/>
    <path d="M12.8498 13.4996H6.99787C6.82542 13.4996 6.66004 13.4311 6.5381 13.3092C6.41616 13.1873 6.34766 13.0219 6.34766 12.8494C6.34766 12.677 6.41616 12.5116 6.5381 12.3897C6.66004 12.2677 6.82542 12.1992 6.99787 12.1992H12.8498C13.0223 12.1992 13.1876 12.2677 13.3096 12.3897C13.4315 12.5116 13.5 12.677 13.5 12.8494C13.5 13.0219 13.4315 13.1873 13.3096 13.3092C13.1876 13.4311 13.0223 13.4996 12.8498 13.4996Z" fill="var(--s247-primary, #B3446D)"/>
  </svg>
);
import { useState } from 'react';
import { useTranslation } from 'react-i18next';
import { useDispatch, useSelector } from 'react-redux';
import {
  c2cOrderPaymentSelectors,
  setNoteAction
} from 'Stores/c2c-order-payment';
import { TypeOrder } from 'Stores/c2c-order-payment/enums';
import { APRICOT_PEACH_BLOSSOM } from 'Utilities/constants';
import { CommentPopup } from '..';
import { DeliveryMethodEnum } from '../../enums';
import './styles.scss';

interface PropsModel {
  className?: string;
}

const TransactionDetail = (props: PropsModel) => {
  const [isOpenNoteOrder, setIsOpenNoteOrder] = useState(false);
  const { className = '' } = props;
  const { t } = useTranslation();
  const dispatch = useDispatch();
  const { typeOrder } = useSelector(c2cOrderPaymentSelectors.get);

  const isPremium = typeOrder === TypeOrder.PREMIUM;
  const isCargo = typeOrder === TypeOrder.CARGO;

  const { productSelected, weightAndSize } = useSelector(
    c2cOrderPaymentSelectors.get
  );

  const onSubmitNote = (note: string) => {
    setIsOpenNoteOrder(false);
    dispatch(setNoteAction(note));
  };

  return (
    <div className={`${className} transaction-detail`}>
      <div className="title-medium">
        {t(DeliveryMethodEnum.TransactionDetail_Title)}
      </div>
      {productSelected && Object.keys(productSelected).length > 0 && (
        <div className="delivery-method-perfume-wrap">
          <span>{productSelected.product}</span>
        </div>
      )}

      <div className="transaction-detail-info">
        <div
          className="transaction-detail-info-icon-wrap"
          onClick={() => setIsOpenNoteOrder(true)}
        >
          <EditIcon />
          <span>{t(DeliveryMethodEnum.TransactionDetail_NoteBtn)}</span>
        </div>

        {productSelected.code !== APRICOT_PEACH_BLOSSOM.code && (
          <div>
            <div className="title-medium-15">
              {t(DeliveryMethodEnum.TransactionDetail_Weight)}
              <span className="text-gray-primary">
                : {weightAndSize.weight} kg
              </span>
            </div>
            <div className="title-medium-15">
              {t(DeliveryMethodEnum.TransactionDetail_Size)}
              <span className="text-gray-primary">
                :{' '}
                {`${weightAndSize.longs || 0}x${weightAndSize.width || 0}x${
                  weightAndSize.height || 0
                } cm`}
              </span>
            </div>
          </div>
        )}
      </div>
      <CommentPopup
        isOpen={isOpenNoteOrder}
        onClose={() => setIsOpenNoteOrder(false)}
        maxLength={200}
        onSubmitNote={onSubmitNote}
      ></CommentPopup>
    </div>
  );
};

export default TransactionDetail;
